import apiClient from '@/shared/api/client';
import { PaginatedConversationsResponse, ConversationDetail } from '../types/messages.types';

interface UnreadCountResponse {
  count: number;
}

class MessagesService {
  async getConversations(
    page = 1,
    limit = 10,
    search?: string
  ): Promise<PaginatedConversationsResponse> {
    return apiClient.get<PaginatedConversationsResponse>('/messages/conversations', {
      params: { page, limit, ...(search && { search }) },
    });
  }

  async getUnreadCount(): Promise<UnreadCountResponse> {
    return apiClient.get<UnreadCountResponse>('/messages/unread-count');
  }

  async getConversationMessages(
    conversationId: string,
    params?: { since?: string }
  ): Promise<ConversationDetail> {
    return apiClient.get<ConversationDetail>(`/messages/conversations/${conversationId}/messages`, {
      params: params?.since ? { since: params.since } : undefined,
    });
  }

  async markConversationRead(conversationId: string): Promise<{ updatedCount: number }> {
    return apiClient.post<{ updatedCount: number }>(
      `/messages/conversations/${conversationId}/read`
    );
  }

  async sendMessage(offerId: string, body: string): Promise<void> {
    return apiClient.post<void>('/messages', { offerId, body });
  }

  async replyToConversation(conversationId: string, body: string): Promise<void> {
    return apiClient.post<void>(`/messages/conversations/${conversationId}/reply`, { body });
  }
}

export const messagesService = new MessagesService();
